/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CouncilApi } from '../api/councils.api';
import { switchMap, map } from 'rxjs/operators';
import { CouncilData, Council } from '../../../interfaces/masters/council';

@Injectable()
export class CouncilService extends CouncilData {

  constructor(private api: CouncilApi) {
    super();
  }


  list(): Observable<Council[]> {
    return this.api.list();
  }

  getById(url:string): Observable<Council>{
      return this.api.getById(url);
  }

  create(url: string, data:Council): Observable<Council> {
    return this.api.add(url,data);
  }

  update(url: string, data:Council): Observable<Council> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
